import { Regions } from '@wicadu/langscope'

import globalTranslations from '@translations/ui/faq-questions/global.json'

export const FAQ_QUESTIONS_TRANSLATIONS = {
  [Regions.Global]: globalTranslations,
} as const
